import { T } from '@transifex/react';
import { t } from '@transifex/native';
import { APIHelpSection } from '@partnerconnect-monorepo/types/HelpSection';
import {
  Tabs,
  TabsList,
  TabsTrigger
} from '@partnerconnect-monorepo/ui/components/ui/tabs';
import { Container } from '@partnerconnect-monorepo/ui/components/composed/container';
import { PageNavigation } from '@partnerconnect-monorepo/ui/components/composed/page-navigation';
import { NoResultsFound } from '@partnerconnect-monorepo/ui/components/composed/no-results-found';
import { HelpSection } from './HelpSection/HelpSection.connect';

interface SupportViewProps {
  helpSections: Array<APIHelpSection>;
}

export const SupportView = ({ helpSections }: SupportViewProps) => (
  <>
    <PageNavigation
      title={<T _str="Partner Connect support" />}
      breadcrumbs={[
        {
          label: t('Partner Connect support')
        }
      ]}
    />
    <Container>
      {helpSections.length > 0 ? (
        <Tabs
          orientation="vertical"
          defaultValue={'' + helpSections[0].id}
          className="flex-wrap"
        >
          <TabsList>
            {helpSections.map((helpSection) => (
              <TabsTrigger key={helpSection.id} value={'' + helpSection.id}>
                {helpSection.title}
              </TabsTrigger>
            ))}
          </TabsList>
          {helpSections.map((helpSection) => (
            <HelpSection key={helpSection.id} helpSection={helpSection} />
          ))}
        </Tabs>
      ) : (
        <NoResultsFound title={t('No support pages available')} />
      )}
    </Container>
  </>
);
